import type { JSX } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './text-area.styles';
interface TextAreaProps extends Omit<JSX.IntrinsicElements['textarea'], 'ref'> {
  /** Marks the field invalid: danger border + danger focus ring + aria-invalid. */
  invalid?: boolean;
}
export function TextArea({
  invalid = false,
  ...props
}: TextAreaProps) {
  return <textarea {...props} aria-invalid={invalid || undefined} {...stylex.props(styles.textarea, invalid && styles.invalid)} />;
}